import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import Datetime from 'react-datetime';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';

import cube_icon from 'assets/img/cube.svg';
import time_icon from 'assets/img/time.svg';
import refresh_icon from 'assets/img/refresh.svg';
import time_icon_overdue from 'assets/img/time_overdue.svg';
import refresh_icon_overdue from 'assets/img/refresh_overdue.svg';
import flag_black_icon from 'assets/img/flag-black.svg';
import calendar_icon from 'assets/img/calendar.svg';

import MaintenanceServices from './services';
import * as MaintenanceEnums from './maintenance-enums';

const CHOICE_LIST = [
  { value: 0, text: 'This month'},
  { value: 1, text: 'Next month'},
  { value: 2, text: 'Last month'}
];

export class ReminderListByLot extends Component {
  static propTypes = {
    history: PropTypes.object,
    dispatch: PropTypes.func,
    lot: PropTypes.object,
    maintenanceTaskReminderList: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.maintenanceService = new MaintenanceServices(this.props.dispatch);
    this.selectedType = CHOICE_LIST[0];
  }

  componentDidMount() {
    this.onChangeFromToDate(this.selectedType);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lot && this.props.lot.value !== prevProps.lot.value) {
      this.refreshScreen();
    }
  }

  // user events
  onChangeFromToDate = (e) => {
    // let fromDate = Moment(localStorage['TODAY']) || Moment();
    let fromDate = Moment();
    let toDate = null;

    switch (e.value) {
      case 0:
        fromDate.startOf('month');
        toDate = fromDate.clone().add(1, 'months').startOf('month');
        break;
      case 1:
        fromDate.add(1, 'months').startOf('month');
        toDate = fromDate.clone().add(1, 'months').startOf('month');
        break;
      case 2:
        toDate = fromDate.startOf('month');
        fromDate = toDate.clone().subtract(1, 'months');
        break;
      default:
        fromDate.startOf('day');
        toDate = fromDate.clone().add(1, 'days').startOf('day');
    }

    this.fromDate = fromDate.utc().format();
    this.toDate = toDate.utc().format();

    this.selectedType = e;
    this.refreshScreen();
  }

  onCheckReminder = (item, checkItem) => {
    this.maintenanceService.updateReminder(item, checkItem.checked, this.props.lot, this.refreshScreen);
  }
  // end user events

  // helpers
  removeQueryParam = (...params) => {
    let queryParams = queryString.parse(location.search);

    params.forEach(key => delete queryParams[key]);
    this.props.history.push({
      pathname: location.pathname,
      search: queryString.stringify(queryParams)
    });
  }

  refreshScreen = () => {
    this.maintenanceService.getTaskReminderList(this.props.lot, this.fromDate, this.toDate);
  }

  getIconForTask= (e) => {
    if (e.recurringType) {
      return e.isOverdued ? time_icon_overdue : time_icon;
    }
    else {
      return e.isOverdued ? refresh_icon_overdue : refresh_icon;
    }
  }

  // end helpers

  // renders
  renderToolTipForTask() {
    return (
      <Tooltip className='tooltip-siteone' id='tool-tip-items'>Check this box if the maintenance item is complete.</Tooltip>
    );
  }

  renderTaskList(itemList) {
    return (
      <React.Fragment>
        <div className='maintenance-task-list' style={{marginTop: '10px'}}>
          {
            Array.isArray(itemList) && itemList.map((e) => {
              return (
                <div key={e.id || _.uniqueId()} className='row'>
                  <div className='col-md-6'>
                    <OverlayTrigger
                      placement='right'
                      delayShow={2000}
                      overlay={this.renderToolTipForTask()}
                    >
                      <div style={{display: 'block', width: '30px'}}>
                        <CheckBoxSingle
                          style={{
                            display: 'inline-block',
                            float: 'left',
                            marginRight: '10px',
                            marginTop: 0,
                            marginBottom: 0
                          }}
                          checked={e.isChecked}
                          onChecked={(ev, value, item) => this.onCheckReminder(e, item)}
                        />
                      </div>
                    </OverlayTrigger>

                    <img className='icon-first-col' src={this.getIconForTask(e)} />
                    <div className='block-with-text' style={{color: e.isOverdued ? 'red' : 'black', marginLeft: '65px'}} >
                      <b>{e.name}</b><br/>
                      {e.description}
                    </div>
                  </div>

                  <div className='col-md-2' style={{paddingTop: '24px'}}>
                    <img className='icon' src={cube_icon} />
                    <div className='sub-block-text'>
                      {
                        e.inventoryItem &&
                          <Link target='_blank' to={this.maintenanceService.buildUrlToInventoryItem(this.props.lot.value, e.inventoryItem.id)}>
                            {e.inventoryItem.name}
                          </Link>
                      }
                      {!e.inventoryItem && '--'}
                    </div>
                  </div>

                  <div className='col-md-2' style={{position: 'relative', paddingTop: '24px'}}>
                    <img className='icon' src={flag_black_icon} />
                    <div className='sub-block-text'>
                      {MaintenanceEnums.REPEAT_PERIODS_LIST[e.repeatType]}
                    </div>
                  </div>

                  <div className='col-md-2' style={{paddingTop: '24px'}}>
                    <img className='icon' src={calendar_icon} />
                    <div className='sub-block-text'>
                      {Moment(e.remindDate).format('MM/DD/YYYY')}
                    </div>
                  </div>
                </div>

              );
            })
          }
        </div>
      </React.Fragment>
    );
  }

  render() {
    let overduedReminders = (this.props.maintenanceTaskReminderList && this.props.maintenanceTaskReminderList.overduedReminders) || [];
    let reminders = (this.props.maintenanceTaskReminderList && this.props.maintenanceTaskReminderList.reminders) || [];

    return (
      <React.Fragment>
        {/* <div style={{display: 'inline-block'}}>
          <Datetime
            timeFormat={false}
            dateFormat='MM/DD/YYYY'
            value={localStorage['TODAY'] || (new Date())}
            onChange={value => {localStorage.setItem('TODAY', Moment(value).format('MM/DD/YYYY')); this.onChangeFromToDate(this.selectedType);}} />
        </div> */}
        <div style={{marginTop: '20px'}}>Overdue items, you should get these done asap</div>
        {this.renderTaskList(overduedReminders)}
        <div style={{marginTop: '30px'}}>
          <span style={{marginRight: '10px'}}>Maintenance activities scheduled</span>
          <Dropdown
            name='reminder_period'
            style={{width: '300px', display: 'inline-block'}}
            className='filestring-dropdown'
            optionLabel='text'
            options={CHOICE_LIST}
            value={this.selectedType}
            onChange={(e) => this.onChangeFromToDate(e.value)}
          />
        </div>

        {this.renderTaskList(reminders)}

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    maintenanceTaskReminderList: state.LotStore.MaintenanceTaskReminderList
  };
};

export default withRouter(connect(mapStateToProps)(ReminderListByLot));




// WEBPACK FOOTER //
// ./src/Lots/Components/Maintenance/reminder-list.js